import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

interface UploadReleaseTrackState {
  releaseTrackId?: number;
  songTitle: string;
  failedReleaseTrackId?: number;
}

const initialState: UploadReleaseTrackState = {
  releaseTrackId: undefined,
  songTitle: "",
  failedReleaseTrackId: undefined,
};

export const uploadReleaseTrackStateAtom = atomWithReset(initialState);

export const uploadReleaseTrackIdAtom = atom(
  (get) => get(uploadReleaseTrackStateAtom).releaseTrackId,
  (get, set, releaseTrackId: number | undefined) => {
    set(uploadReleaseTrackStateAtom, {
      ...get(uploadReleaseTrackStateAtom),
      releaseTrackId,
    });
  },
);

export const uploadReleaseTrackSongTitleAtom = atom(
  (get) => get(uploadReleaseTrackStateAtom).releaseTrackId,
  (get, set, songTitle: string) => {
    set(uploadReleaseTrackStateAtom, {
      ...get(uploadReleaseTrackStateAtom),
      songTitle,
    });
  },
);

export const failedReleaseTrackUploadStateAtom = atom(
  (get) => get(uploadReleaseTrackStateAtom).releaseTrackId,
  (get, set) => {
    set(uploadReleaseTrackStateAtom, {
      failedReleaseTrackId: get(uploadReleaseTrackStateAtom).releaseTrackId,
      songTitle: "",
      releaseTrackId: undefined,
    });
  },
);

export const reuploadReleaseTrackUploadStateAtom = atom(
  (get) => get(uploadReleaseTrackStateAtom).releaseTrackId,
  (_, set, releaseTrackId: number) => {
    set(uploadReleaseTrackStateAtom, {
      failedReleaseTrackId: releaseTrackId,
      songTitle: "",
      releaseTrackId,
    });
  },
);
